export default "__VITE_ASSET__D2XKYr7S__"